module.exports = __webpack_public_path__ + "static/media/bodyweight.3f4a9c5d.svg";